var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-left":"10px"}},[_c('span',[_c('div',{staticStyle:{"float":"left","width":"150px","margin-right":"15px"}},[_vm._v(_vm._s(_vm.parameter.Name)+":")]),_c('div',{style:(_vm.voltageStyle)},[_vm._v(_vm._s(_vm.parameter.Actual))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }